<h1 mat-dialog-title *ngIf="data && data.title">{{data.title}}</h1>
<div mat-dialog-content *ngIf="data && data.message">
  <p>{{ data.message }}?</p>


  <!--cancel reason available only for canceling appointment-->
  <div *ngIf="actionType === DELETE_APPT_ACTION" class="mt-2">
    <mat-form-field class="w-100">
      <mat-select placeholder="{{ 'COMMON.CANCEL-REASON' | translate }}" [(ngModel)]="data.cancelReasonID">
        <mat-option *ngFor="let currentReason of cancelReasons" [value]="currentReason.ID">
          {{currentReason.Name}} </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="w-100">
      <mat-label>{{ 'COMMON.NOTE' | translate }}</mat-label>
      <textarea matInput cdkTextareaAutosize placeholder="{{ 'COMMON.NOTE' | translate }}" [(ngModel)]="data.cancelReason"
        maxlength="256"></textarea>
    </mat-form-field>
    <!-- <mat-form-field class="w-100">
      <mat-label>{{ 'COMMON.NOTE' | translate }}</mat-label>
      <mat-checkbox matInput cdkTextareaAutosize placeholder="{{ 'COMMON.NOTE' | translate }}" [(ngModel)]="data.alsoDeleteTreatments"
        maxlength="256"></mat-checkbox>
    </mat-form-field> -->

    <section class="horizontal-section">
      <mat-checkbox class="horizontal-margin"  [(ngModel)]="data.alsoDeleteTreatments">{{ 'COMMON.DELETE-ASSOCIATED-TREATMENTS-TO-THIS-EVENT' | translate }}</mat-checkbox>
    </section>
  </div>

</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">{{'COMMON.CANCEL' | translate}}</button>
  <button mat-button [mat-dialog-close]="getData()" cdkFocusInitial [disabled]="!isValid()">{{'COMMON.OK' | translate}}</button>
</div>